import styled from 'react-emotion';

export const Turnout = styled.div`
	background: #f5f5f5;
	border: 1px solid #d9d9d9;
	display: flex;
	margin-top: 1.315rem;
	margin-bottom: 2.5rem;

	@media (max-width: 480px) {
		display: block;
	}
`;

export const Part = styled.div`
	box-sizing: border-box;
	display: flex;
	flex: 0 1 50%;
	justify-content: space-between;
	margin: 1rem;
`

export const Label = styled.div`
	padding-right: 1rem;
`;

export const Value = styled.div`
	font-weight: 300;
	text-align: right;
`
